// Generated by Melange

import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__GetArtistInfo2 from "../api/subsonic/getArtistInfo2.jsx";

function make(artistId) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetArtistInfo2.make(artistId, undefined, true, undefined), {
      credentials: state.auth.credentials
    }), (function (param) {
      const similarArtist = param.similarArtist;
      const artistInfo_biography = param.biography;
      const artistInfo_lastFmUrl = param.lastFmUrl;
      const artistInfo_musicBrainzId = param.musicBrainzId;
      const artistInfo = {
        biography: artistInfo_biography,
        lastFmUrl: artistInfo_lastFmUrl,
        musicBrainzId: artistInfo_musicBrainzId
      };
      const state = store.getState();
      const artistInfoById = MergeIntoMap.mergeIntoMap(state.artists.artistInfoById, [artistInfo], (function (param) {
        return artistId;
      }));
      const state$1 = store.getState();
      const byId = similarArtist !== undefined ? MergeIntoMap.mergeIntoMap(state$1.artists.byId, Belt__Belt_Array.keepMap(similarArtist, (function (artist) {
          if (artist.TAG !== /* Artist */ 0) {
            return;
          }
          const artist$1 = artist._0;
          const original = state$1.artists.byId.get(artist$1.id);
          if (original !== undefined) {
            return {
              albumCount: artist$1.albumCount,
              coverArt: artist$1.coverArt,
              id: original.id,
              musicBrainzId: artist$1.musicBrainzId,
              name: artist$1.name,
              starred: artist$1.starred,
              userRating: artist$1.userRating
            };
          } else {
            return artist$1;
          }
        })), (function (x) {
          return x.id;
        })) : state$1.artists.byId;
      const state$2 = store.getState();
      const arg = [];
      const similarArtistsById = MergeIntoMap.mergeIntoMap(state$2.artists.similarArtistsById, [(function (param) {
          return Stdlib__Option.value(param, arg);
        })(similarArtist)], (function (param) {
        return artistId;
      }));
      const state$3 = store.getState();
      if (artistInfoById !== state$3.artists.artistInfoById || byId !== state$3.artists.byId || similarArtistsById !== state$3.artists.similarArtistsById) {
        store.setState(function (prevState) {
          const init = prevState.artists;
          return {
            albums: prevState.albums,
            artists: {
              albumIdsByArtistId: init.albumIdsByArtistId,
              artistInfoById: artistInfoById,
              byId: byId,
              listIds: init.listIds,
              similarArtistsById: similarArtistsById,
              topSongIdsByArtistName: init.topSongIdsByArtistName
            },
            auth: prevState.auth,
            player: prevState.player,
            songs: prevState.songs
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
